// @flow
import { KEY } from './constants'

export const getTickets = (state) => state[KEY].tickets
